import { clearStoredProducts } from "./storage";

let confirmInitialized = false;

export const initCompareConfirm = ({ onConfirm } = {}) => {
  if (confirmInitialized) return;
  confirmInitialized = true;

  let pendingAction = null;

  const getModal = () => document.querySelector("[data-confirm-modal]");

  const open = () => {
    const modal = getModal();
    if (!modal) return;
    modal.hidden = false;
  };

  const close = () => {
    const modal = getModal();
    if (!modal) return;
    modal.hidden = true;
    pendingAction = null;
  };

  document.addEventListener("click", async (event) => {
    const clearButton = event.target.closest("[data-clear-compare]");
    const cancel = event.target.closest("[data-confirm-cancel]");
    const confirm = event.target.closest("[data-confirm-ok]");
    const overlay = event.target.closest("[data-confirm-close]");

    if (clearButton) {
      event.preventDefault();
      console.log(123);
      
      pendingAction = async () => {
        clearStoredProducts();

        if (typeof onConfirm === "function") {
          await onConfirm();
        }
      };

      open();
      return;
    }

    if (confirm) {
      await pendingAction?.();
      close();
      return;
    }

    if (cancel || overlay) {
      close();
    }
  });
};